const sortByTemplate = {
    SortByTemplate: {
        baseStyle: () => ({
            radioWrapper: {
                w: '100%',
                py: 'spacing.11',
                px: 'spacing.6',
                sx: {
                    '.chakra-stack': {
                        w: '100%',
                        alignItems: 'flex-start',
                        gap: 'spacing.14',
                        label: {
                            w: '100%',
                            p: 0,
                            span: {
                                textStyle: 'paragraphSm',
                            },
                        },
                    },
                },
            },
        }),
    },
}

export default sortByTemplate
